const storage = {
    set(key, value) {
        try {
            const data = typeof value === 'string' ? value : JSON.stringify(value);
            localStorage.setItem(key, data);
        } catch (err) {
            console.error('Storage set error:', err);
        }
    },

    get(key) {
        try {
            const value = localStorage.getItem(key);
            try {
                return JSON.parse(value);
            } catch {
                return value;
            }
        } catch (err) {
            console.error('Storage get error:', err);
            return null;
        }
    },

    remove(key) {
        localStorage.removeItem(key);
    },

    async clear(getDeviceId) {
        try {
            let deviceId = this.get("device_id");

            localStorage.clear();

            if (getDeviceId) {
                deviceId = await getDeviceId();
            }

            if (deviceId) {
                this.set("device_id", deviceId);
            }

            return deviceId;

        } catch (err) {
            console.error("Storage clear error:", err);
            return null;
        }
    },
};

export default storage;